import {
  TAppSyncScreenItem,
  TBctxItemWithoutSize,
  TFilteredDataInfo,
  TMasterDataListMetaData,
  TMasterdataListDB,
  TMasterdataSyncStatus,
  TREQUEST_AddSilhouetteOperations,
  TREQUEST_GetBulkSilhouetteOperations,
  TREQUEST_GetSilhouetteOperations,
  TRESPONSE_correctiveReasons,
  TUpdateFilteredListsV3,
} from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum InputAppMasterdataListDBActionTypes {
  InitializeMasterdataListStore = 'InitializeMasterdataListStore',
  SetMasterdataListsStore = 'InitializeMasterdataListStoreSuccess',
  UpdateFilteredListsSuccess = 'UpdateFilteredListsSuccess',
  UpdateFilteredListsV3Success = 'UpdateFilteredListsV3Success',
  SetMasterdataListsStoreAndLoadAllMasterdataListsAndSilhouetteKeys = 'SetMasterdataListsStoreAndLoadAllMasterdataListsAndSilhouetteKeys',
  NoMasterdataAction = 'NoMasterdataAction',
  LoadSilhouetteInfo = 'LoadSilhouetteInfo',
  LoadAllMasterdataLists = 'LoadAllMasterdataLists',
  SetAllMasterdataListsAndLoadSilhouetteInfo = 'SetAllMasterdataListsAndLoadSilhouetteInfo',
  SetSilhouetteInfoAndDownloadSilhouetteAssets = 'SetSilhouetteInfoAndDownloadSilhouetteAssets',
  DownloadSilhouetteAssets = 'DownloadSilhouetteAssets',
  WriteSilhoutteAssetsInAndroidOriOSStorage = 'WriteSilhoutteAssetsInAndroidOriOSStorage',
  SetSilhouetteInfo = 'SetSilhouetteInfo',
  SetSilhouetteInfoAndLoadSilhouetteOperations = 'SetSilhouetteInfoAndLoadSilhouetteOperations',
  AddOrUpdateMasterdataListByName = 'AddOrUpdateMasterdataListByName',
  UpdateFilteredLists = 'UpdateFilteredLists',
  UpdateMasterdataListStore = 'UpdateMasterdataListStore',
  UpdateMasterdataListStoreAndDownloadSilhouetteAssets = 'UpdateMasterdataListStoreAndDownloadSilhouetteAssets',
  LoadCorrectiveReasons = 'LoadCorrectiveReasons',
  LoadCorrectiveReasonsSuccess = 'LoadCorrectiveReasonsSuccess',
  LoadOperationsAndIssuesV2 = 'LoadOperationsAndIssuesV2',
  SetAllMasterdataListsV2AndLoadAllMasterdataLists = 'SetAllMasterdataListsV2AndLoadAllMasterdataLists',
  LoadSilhouetteOperations = 'LoadSilhouetteOperations',
  UpdateFilteredRejectList = 'UpdateFilteredRejectList',
  UpdateFilteredListsV3 = 'UpdateFilteredListsV3',
  UpdateMasterdataListStoreAndEmitSizeListLoadedSubscription = 'UpdateMasterdataListStoreAndEmitSizeListLoadedSubscription',
  LoadRCAHierarchicalData = 'LoadRCAHierarchicalData',
}
export class LoadOperationsAndIssuesV2 implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.LoadOperationsAndIssuesV2;
  constructor(
    public chainWithLoadAllMasterdataLists: boolean,
    public chainWithLoadSilhouetteInfo: boolean,
    public bctxLists: TBctxItemWithoutSize[][],
    public subjectKey: string,
    public masterdataListKeys: string[],
    public departments: string[],
    public masterdataListConf: string[],
    public silhouetteListConf: string[],
    public masterDataListMetaData: TMasterDataListMetaData,
  ) {}
}

export class LoadSilhouetteOperations implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.LoadSilhouetteOperations;
  constructor(
    public bctxLists: TBctxItemWithoutSize[][],
    public silhouetteListConf: string[],
    public subjectKey: string,
  ) {}
}

export class SetAllMasterdataListsV2AndLoadAllMasterdataLists implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.SetAllMasterdataListsV2AndLoadAllMasterdataLists;
  constructor(
    public masterdataListDB: TMasterdataListDB,
    public chainWithLoadSilhouetteInfo: boolean,
    public bctxLists: TBctxItemWithoutSize[][],
    public masterdataListKeys: string[],
    public subjectKey: string,
    public masterdataListConf: string[],
    public silhouetteListConf: string[],
    public masterDataListMetaData: TMasterDataListMetaData,
  ) {}
}
export class LoadAllMasterdataLists implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.LoadAllMasterdataLists;
  constructor(
    public chainWithLoadSilhouetteInfo: boolean,
    public bctxLists: TBctxItemWithoutSize[][],
    public masterdataListKeys: string[],
    public subjectKey: string,
    public masterdataListConf: string[],
    public silhouetteListConf: string[],
    public masterDataListMetaData: TMasterDataListMetaData,
  ) {}
}

export class AddOrUpdateMasterdataListByName implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.AddOrUpdateMasterdataListByName;
  constructor(
    public bctxLists: TBctxItemWithoutSize[][],
    public appSyncScreenItem: TAppSyncScreenItem,
    public subjectKey: string,
    public masterdataListConf: string[],
  ) {}
}

export class UpdateFilteredLists implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.UpdateFilteredLists;
  constructor(public id: string, public bctx: TBctxItemWithoutSize[], public list: string[]) {}
}

export class UpdateFilteredListsV3 implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.UpdateFilteredListsV3;
  constructor(public bctx: TBctxItemWithoutSize[], public updatedFilteredListData: TUpdateFilteredListsV3) {}
}

export class UpdateFilteredRejectList implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.UpdateFilteredRejectList;
  constructor(public filteredList: string[], public department: string) {}
}

export class LoadSilhouetteInfo implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.LoadSilhouetteInfo;
  constructor(public bctxLists: TBctxItemWithoutSize[][], public subjectKey: string, public listConf: string[] = []) {}
}

export class DownloadSilhouetteAssets implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.DownloadSilhouetteAssets;
  constructor() {}
}

export class WriteSilhoutteAssetsInAndroidOriOSStorage implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.WriteSilhoutteAssetsInAndroidOriOSStorage;
  constructor(public data: Blob) {}
}
export class NoMasterdataAction implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.NoMasterdataAction;
  constructor() {}
}

export class InitializeMasterdataListStore implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.InitializeMasterdataListStore;
  constructor(public chainWithInitClientDB: boolean, public chainWithInitCpiDB?: boolean, public chainWithLoadRCAHierarchicalData?: boolean) {}
}

export class SetSilhouetteInfoAndDownloadSilhouetteAssets implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.SetSilhouetteInfoAndDownloadSilhouetteAssets;
  constructor(public silhouetteKeysInfo: TMasterdataListDB['silhouetteKeysInfo']) {}
}

export class SetSilhouetteInfo implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.SetSilhouetteInfo;
  constructor(public silhouetteKeysInfo: TMasterdataListDB['silhouetteKeysInfo']) {}
}

export class SetSilhouetteInfoAndLoadSilhouetteOperations implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.SetSilhouetteInfoAndLoadSilhouetteOperations;
  constructor(
    public silhouetteKeysInfo: TMasterdataListDB['silhouetteKeysInfo'],
    public bctxLists: TBctxItemWithoutSize[][],
    public silhouetteListConf: string[],
    public subjectKey: string,
  ) {}
}

export class SetAllMasterdataListsAndLoadSilhouetteInfo implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.SetAllMasterdataListsAndLoadSilhouetteInfo;
  constructor(
    public masterdataListDB: TMasterdataListDB,
    public bctxLists: TBctxItemWithoutSize[][],
    public subjectKey: string,
    public listConf: string[] = [],
    public masterDataListMetaData: TMasterDataListMetaData,
  ) {}
}

export class SetMasterdataListsStore implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.SetMasterdataListsStore;
  constructor(
    public masterdataListDB: TMasterdataListDB,
    public chainWithInitClientDB = false,
    public chainWithInitCpiDB?: boolean,
    public chainWithLoadRCAHierarchicalData?: boolean,
  ) {}
}

export class UpdateFilteredListsSuccess implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.UpdateFilteredListsSuccess;
  constructor(public masterdataListDB: TMasterdataListDB) {}
}

export class UpdateFilteredListsV3Success implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.UpdateFilteredListsV3Success;
  constructor(public masterdataListDB: TMasterdataListDB) {}
}

export class SetMasterdataListsStoreAndLoadAllMasterdataListsAndSilhouetteKeys implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.SetMasterdataListsStoreAndLoadAllMasterdataListsAndSilhouetteKeys;
  constructor(public masterdataListDB: TMasterdataListDB, public masterDataListMetaData: TMasterDataListMetaData) {}
}

export class UpdateMasterdataListStore implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.UpdateMasterdataListStore;
  constructor(public masterdataListDB: TMasterdataListDB) {}
}

export class UpdateMasterdataListStoreAndEmitSizeListLoadedSubscription implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.UpdateMasterdataListStoreAndEmitSizeListLoadedSubscription;
  constructor(
    public masterdataListDB: TMasterdataListDB,
    public isSizeListLoaded: boolean,
    public masterDataListMetaData: TMasterDataListMetaData,
  ) {}
}

export class UpdateMasterdataListStoreAndDownloadSilhouetteAssets implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.UpdateMasterdataListStoreAndDownloadSilhouetteAssets;
  constructor(public masterdataListDB: TMasterdataListDB) {}
}

export class LoadCorrectiveReasons implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.LoadCorrectiveReasons;
  constructor(
    public listKey: string,
    public chainWithLoadAllMasterdataListsAndSilhouetteKeys: boolean,
    public masterDataListMetaData: TMasterDataListMetaData,
  ) {}
}

export class LoadCorrectiveReasonsSuccess implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.LoadCorrectiveReasonsSuccess;
  constructor(
    public res: TRESPONSE_correctiveReasons,
    public chainWithLoadAllMasterdataListsAndSilhouetteKeys: boolean,
    public masterDataListMetaData: TMasterDataListMetaData,
  ) {}
}

export class LoadRCAHierarchicalData implements Action {
  readonly type = InputAppMasterdataListDBActionTypes.LoadRCAHierarchicalData;
  constructor(public init: boolean, public factoryId: string) {}
}

export type TInputAppMasterdataListActions =
  | LoadSilhouetteInfo
  | SetMasterdataListsStore
  | SetAllMasterdataListsAndLoadSilhouetteInfo
  | SetSilhouetteInfoAndDownloadSilhouetteAssets
  | LoadAllMasterdataLists
  | InitializeMasterdataListStore
  | SetSilhouetteInfo
  | SetSilhouetteInfoAndLoadSilhouetteOperations
  | DownloadSilhouetteAssets
  | WriteSilhoutteAssetsInAndroidOriOSStorage
  | LoadCorrectiveReasons
  | LoadCorrectiveReasonsSuccess
  | UpdateMasterdataListStore
  | SetMasterdataListsStoreAndLoadAllMasterdataListsAndSilhouetteKeys
  | SetAllMasterdataListsV2AndLoadAllMasterdataLists
  | UpdateFilteredListsSuccess
  | UpdateFilteredListsV3Success
  | UpdateMasterdataListStoreAndDownloadSilhouetteAssets
  | NoMasterdataAction
  | UpdateFilteredRejectList
  | UpdateMasterdataListStoreAndEmitSizeListLoadedSubscription
  | LoadRCAHierarchicalData;
